module.exports = __webpack_public_path__ + "img/pic18.4fb9480d.png";